import { addLocaleData } from 'react-intl';

import deData from 'react-intl/locale-data/de';
import enData from 'react-intl/locale-data/en';

import de from './messages/de.json';
import { ILanguageSettings } from '@oceanjs/core';

addLocaleData(deData);
addLocaleData(enData);

export const languageSettings: ILanguageSettings = {
  messages: { de },
  default: 'de',
};
